import React from "react";
import {voteResultsService} from "../_services";
import {toast} from "react-toastify";

class ResetAnswers extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            confirming: false
        }
    }

    render() {
        return this.state.confirming ? (
            <form name="form">
                <p>Please confirm you want to remove all the answers</p>

                <div>
                    <button type="button" className="btn btn-primary" onClick={this._resetVotes}>Confirm</button>
                    <button type="button" className="btn btn-link ms-16" onClick={this._goToInitial}>Cancel</button>
                </div>
            </form>) :
            (<div className="form-group">
                <button className="btn btn-primary" onClick={this._goToConfirming}>Delete All Answers
            </button>
        </div>);
    }

    _goToConfirming = () => {
        this.setState({ confirming: true });
    }

    _goToInitial = () => {
        this.setState({
            confirming: false
        })
    }

    _resetVotes = () => {
        // todo migrate to redux
        voteResultsService.resetVotes()
            .then(
                ()=>{
                    toast("All answers have been deleted!");
                },
                error => {
                    toast("error!");
                })
            .finally(() => {
                this._goToInitial();
            });
    }
}

export default ResetAnswers;

